"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import kidsPattern from '../../../../public/kidspattern.png';
export function useKidsTheme(slug) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== slug) {
    t0 = () => {
      if (slug !== "kids") {
        return;
      }
      const body = document.body;
      const prevBg = body.style.background;
      body.classList.add("kids-page");
      return () => {
        body.style.background = prevBg;
        body.classList.remove("kids-page");
      };
    };
    t1 = [slug];
    $[0] = slug;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}